export default "__VITE_ASSET__DBpLn8Pc__"